import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';

/**
 * Rutas de revisión de hallazgos dentro de la vista de admin: solo para correos guardados con "+" al
 * inicio en la BD (el backend lo manda como `asesor.gestionIssues`). El resto va al dashboard.
 */
export function GestionIssuesRoute() {
  const { user } = useAuth();
  return user?.asesor?.gestionIssues ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
